import { AxiosInstance } from 'axios';
import * as Sentry from '@sentry/react';
import { config } from 'config';
import { AxiosClient, AxiosUtils } from '../AxiosClient/AxiosClient';
import { VehicleDescription } from 'types';
import { SERVICE_DOWN } from 'api/errors';

class VehicleEquipmentsOptionsPacks {
  private readonly client: AxiosInstance;

  constructor() {
    this.client = AxiosClient.get({
      baseURL: config.URL_VEHICLE_DESCRIPTION,
    });
  }

  async getVehicleEquipmentsOptionsPacks(
    versionId = '0',
    category: string,
    mecDate: string,
    isFirstCall: boolean,
    selectedEquipOptPack?: string[],
  ): Promise<VehicleDescription | undefined> {
    return this.client
      .post<VehicleDescription>(
        'v1/handle-equipments-options-packs',
        {
          category: DAB_CATEGORIES[category] ?? category,
          mecDate,
          versionId: Number.parseInt(versionId),
          isFirstCall,
          selectedEquipOptPack,
        },
        {
          headers: AxiosClient.getAuthorizationHeader(),
        },
      )
      .then(result => {
        return result.data;
      })
      .catch(error => {
        Sentry.captureException(error, {
          tags: {
            api: 'Equipements-Options-Packs',
            endpoint: 'handle-equipments-options-packs',
            ...AxiosUtils.enrichTags(error),
          },
        });
        return Promise.reject({ message: SERVICE_DOWN });
      });
  }
}

export const VehicleDescriptionService = new VehicleEquipmentsOptionsPacks();

const DAB_CATEGORIES: Record<string, string> = {
  CITADINE: 'CITADINE',
  MOYENNE_BERLINE: 'MOYENNE_BERLINE',
  GRANDE_BERLINE: 'GRANDE_BERLINE',
  BREAK: 'BREAK',
  MONOSPACE: 'MONOSPACE',
  COUPE: 'COUPE',
  CABRIOLET: 'CABRIOLET',
  TOUS_CHEMINS: 'TOUS_CHEMINS',
  VOITURETTE: 'VOITURETTE',
  VEHICULE_SOCIETE: 'VEHICULE_SOCIETE',
  FOURGON_MOINS_3T5: 'FOURGON_MOINS_3T5',
  CAMION_PLUS_3T5: 'CAMION_PLUS_3T5',
  MINIBUS: 'MINIBUS',
  FOURGONETTE: 'FOURGONETTE',
  PICK_UP: 'PICK_UP',
  REMORQUES_SEULS: 'REMORQUES_SEULS',
  PROFILE: 'CAMPING_CAR',
  FOURGON_AMENAGE: 'CAMPING_CAR',
  INTEGRAL: 'CAMPING_CAR',
  CAPUCINE: 'CAMPING_CAR',
  CARAVANNE: 'CARAVANE',
  MOBIL_HOME: 'CARAVANE',
  CUSTOM: 'MOTO',
  OFFROAD: 'MOTO',
  ROADSTER: 'MOTO',
  GT: 'MOTO',
  MINI_MOTO: 'MOTO',
  MOBYLETTE: 'MOTO',
  SUPERMOTARD: 'MOTO',
  TRAIL: 'MOTO',
  SPORTIVE: 'MOTO',
  QUAD: 'MOTO',
  SCOOTER: 'MOTO',
  SIDE_CARS: 'MOTO',
  SIDE_CAR: 'MOTO',
};
